import type { CityConfig } from "../city-template/types";

export const mcleanVaConfig: CityConfig = {
  city: "McLean",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "mclean-va",
  route: "/cities/mclean-va",
  title: "Emergency Passport McLean, VA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in McLean, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Tysons Corner, Vienna, Falls Church, Great Falls, Reston, and all of Northern Virginia. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in McLean, VA",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help McLean and Northern Virginia's most affluent travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20upscale%20suburban%20neighborhood%20in%20McLean%20Virginia%20at%20golden%20hour%20with%20elegant%20brick%20estates%2C%20manicured%20lawns%2C%20and%20mature%20oak%20trees%20lining%20winding%20streets%2C%20Tysons%20Corner%20skyline%20visible%20in%20the%20distant%20background%2C%20soft%20warm%20evening%20light%20creating%20a%20serene%20luxurious%20atmosphere%2C%20green%20summer%20foliage%2C%20professional%20real%20estate%20photography%20with%20warm%20tones%20and%20rich%20detail%2C%20no%20people%20or%20vehicles%20visible&width=1800&height=700&seq=mclean-va-hero-001&orientation=landscape",
  heroImageAlt: "Upscale McLean Virginia suburban neighborhood with elegant homes and Tysons Corner skyline",
  geoPosition: "38.9339;-77.1773",
  geoPlacename: "McLean, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 12 miles from McLean via I-66",
  },
  nearbyCitiesZips: [
    { name: "McLean", zips: "22101, 22102, 22106, 22107" },
    { name: "Tysons Corner", zips: "22102" },
    { name: "Vienna", zips: "22180–22182" },
    { name: "Falls Church", zips: "22040–22046" },
    { name: "Great Falls", zips: "22066" },
    { name: "Oakton", zips: "22124" },
    { name: "Reston", zips: "20190–20194" },
    { name: "Herndon", zips: "20170–20172" },
    { name: "Merrifield", zips: "22116" },
    { name: "Dunn Loring", zips: "22027" },
    { name: "Pimmit Hills", zips: "22043" },
    { name: "Idylwood", zips: "22043" },
    { name: "Arlington", zips: "22201–22217" },
    { name: "Alexandria", zips: "22301–22315" },
    { name: "Fairfax", zips: "22030–22039" },
    { name: "Annandale", zips: "22003" },
    { name: "Springfield", zips: "22150–22153" },
    { name: "Burke", zips: "22015" },
    { name: "Centreville", zips: "20120, 20121" },
    { name: "Chantilly", zips: "20151, 20152" },
    { name: "Sterling", zips: "20164, 20165" },
    { name: "Ashburn", zips: "20147, 20148" },
    { name: "Leesburg", zips: "20175, 20176" },
    { name: "Manassas", zips: "20110, 20111" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent McLean departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "NoVA Elite Hub", desc: "Serving McLean, Tysons, Vienna, Great Falls, and all of Northern Virginia" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Arlington VA passport services", route: "/cities/arlington-va" },
    { name: "Alexandria VA passport services", route: "/cities/alexandria-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves McLean remotely via secure courier. We do not have a walk-in office in McLean — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for McLean and Northern Virginia travelers.",
  fpcOfficeDistance: "Serving all of McLean and the surrounding Northern Virginia area including Tysons Corner, Vienna, Falls Church, Great Falls, Oakton, Reston, Herndon, and Fairfax County",
  serviceAreaIntro: "From the elegant estates of McLean and Great Falls to the bustling corporate corridors of Tysons Corner, from the charming town center of Vienna to the quiet neighborhoods of Oakton and Reston — Fast Passport Center serves every corner of Northern Virginia's most affluent communities. We regularly help travelers from Falls Church, Herndon, Annandale, Springfield, and Fairfax get their passports fast.",
  nearbyCitiesIntro: "We serve all McLean neighborhoods and the surrounding Northern Virginia metro area including Tysons Corner, Vienna, Falls Church, Great Falls, Oakton, Reston, Herndon, Merrifield, Dunn Loring, Pimmit Hills, Idylwood, Arlington, Alexandria, Fairfax, Annandale, Springfield, Burke, Centreville, Chantilly, Sterling, Ashburn, Leesburg, and Manassas. If you are anywhere in the Northern Virginia region, we have you covered.",
  howItWorksIntro: "Most McLean travelers complete everything online and ship documents overnight. No need to drive into Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "McLean travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "McLean and Northern Virginia travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in McLean? Here are the most common ones we hear from Northern Virginia travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent McLean international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Elizabeth H.",
      location: "McLean, VA",
      rating: 5,
      text: "My passport expired the week before a family trip to the Amalfi Coast. Fast Passport Center had my renewal ready in 4 days. I dropped my documents at the Tysons UPS and never had to think about it again. Truly white-glove service.",
      service: "Passport Renewal",
    },
    {
      name: "Richard T.",
      location: "Great Falls, VA",
      rating: 5,
      text: "Emergency passport for a business deal in Dubai. I was told I might have to drive to DC and wait all day. Fast Passport Center had it in my hands in 32 hours. Their communication was impeccable.",
      service: "Emergency Passport",
    },
    {
      name: "Catherine M.",
      location: "Vienna, VA",
      rating: 5,
      text: "First passports for my three children before our European summer trip. Fast Passport Center handled the parental consent requirements flawlessly and had all three passports in 5 days. I couldn't have managed this without them.",
      service: "Child Passport",
    },
    {
      name: "James K.",
      location: "Tysons Corner, VA",
      rating: 5,
      text: "Lost my passport 48 hours before a flight to Singapore. I was panicking. Fast Passport Center had a replacement in my hands in 30 hours. They saved a quarter-million-dollar client meeting.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "mclean-va-1",
      name: "McLean Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1361 Chain Bridge Rd",
      city: "McLean",
      state: "VA",
      zip: "22101",
      phone: "(703) 356-4216",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central McLean, near downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary McLean facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "mclean-va-2",
      name: "Tysons Corner Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1580 Spring Hill Rd",
      city: "Vienna",
      state: "VA",
      zip: "22182",
      phone: "(703) 893-3708",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Tysons Corner, near the Galleria",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Tysons Corner and east McLean area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "mclean-va-3",
      name: "Vienna Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 Lawyers Rd NW",
      city: "Vienna",
      state: "VA",
      zip: "22180",
      phone: "(703) 938-3551",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Vienna, near the town center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Vienna and south McLean. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "mclean-va-4",
      name: "Falls Church Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7777 Maple Pl",
      city: "Falls Church",
      state: "VA",
      zip: "22043",
      phone: "(703) 534-4621",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Falls Church, east of McLean",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Falls Church and east McLean area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "mclean-va-5",
      name: "Fairfax County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "4110 Chain Bridge Rd",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 691-7320",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Fairfax County Government Center",
      website: "https://www.fairfaxcounty.gov/",
      websiteLabel: "Fairfax County Clerk",
      notes: "Major county facility for Fairfax County. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "mclean-va-6",
      name: "Reston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11110 Reston Station Blvd",
      city: "Reston",
      state: "VA",
      zip: "20190",
      phone: "(703) 476-5554",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Reston Town Center, west of McLean",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Reston and western Fairfax County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive into downtown DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "McLean photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Northern Virginia acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many McLean applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many McLean families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "McLean travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in McLean or Tysons." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your McLean address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in McLean before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in McLean for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the drive into downtown Washington, DC." },
    { q: "How fast can I renew my passport in McLean?", a: "Fast Passport Center offers fast passport renewal in McLean in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to McLean?", a: "The nearest regional passport agency to McLean is the Washington Passport Agency, located approximately 12 miles away in downtown Washington, DC. For urgent processing without navigating DC traffic and parking, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from McLean without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near McLean?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for McLean residents." },
    { q: "Can I expedite a child passport in McLean?", a: "Yes. Fast Passport Center expedites child passports in McLean for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk McLean families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in McLean with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in McLean?", a: "With Fast Passport Center's emergency courier service, McLean travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near McLean?", a: "Popular options include the McLean Post Office (22101), Tysons Corner Post Office (22182), Vienna Post Office (22180), Falls Church Post Office (22043), Fairfax County Clerk (22030), and Reston Post Office (20190). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in McLean?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the DC traffic and parking hassle." },
    { q: "What if I live in a smaller Fairfax County town?", a: "We serve the entire Fairfax County and Northern Virginia region including Tysons, Vienna, Falls Church, Great Falls, Oakton, Reston, Herndon, Annandale, Springfield, Burke, Centreville, Chantilly, Sterling, Ashburn, Leesburg, and Manassas. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in McLean?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in McLean?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx Office locations in McLean, Tysons, and Vienna offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in McLean?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in McLean?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk McLean families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — McLean", address: "1430 Chain Bridge Rd, McLean, VA 22101", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Tysons", address: "8447 Leesburg Pike, Vienna, VA 22182", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Tysons", address: "7930 Tysons Corner Center, McLean, VA 22102", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Vienna", address: "212 Maple Ave E, Vienna, VA 22180", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Falls Church", address: "311 E Broad St, Falls Church, VA 22046", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Reston", address: "11990 Market St, Reston, VA 20190", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Fairfax", address: "10430 Main St, Fairfax, VA 22030", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Herndon", address: "12960 Worldgate Dr, Herndon, VA 20170", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Tysons",
      address: "1960 Chain Bridge Rd, Tysons, VA 22102",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Fairfax",
      address: "4110 Chain Bridge Rd, Fairfax, VA 22030",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Falls Church",
      address: "104 W Broad St, Falls Church, VA 22046",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Falls Church and east McLean residents. REAL ID available.",
      featured: false,
    },
    {
      name: "Virginia DMV — Sterling",
      address: "22370 S Sterling Blvd, Sterling, VA 20164",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves western Fairfax County and Loudoun County. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "12 miles west of McLean",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "The primary international airport for McLean and Northern Virginia. Major hub for long-haul flights to Europe, Asia, and the Caribbean. Accessible via Dulles Toll Road.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "12 miles southeast of McLean",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Alternative major airport for domestic flights and international connections. Accessible via I-66 and GW Parkway.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "50 miles northeast of McLean",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative international hub for international flights. Accessible via I-95.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};